module.exports = __webpack_public_path__ + "files/9759c8e699b4a6d4325e2c151fd12cf5.png";